package org.example.zone360.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AddVideoSession(
    val message: String? = null,
    @SerialName("sessionID")
    val sessionId: String? = null,
    val error: String? = null
)